import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API



export const detalhesDashboardAdministrador = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/dashboard-admin/`, 'GET');
}

export const detalhesDashboardUsuarioComum = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/dashboard-usuario-comum/`, 'GET');
}

export const exportarMaisBaixadosUsuarioComum = async () => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}Dashboard/gerar-exel-mais-baixados-usuario-comum/`, 'GET');
}

export const exportarMaisBaixadosAdministrador = async () => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}Dashboard/gerar-exel-mais-baixados-administrador/`, 'GET');
}

export const exportarArquivos = async () => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}Dashboard/gerar-exel-arquivos/`, 'GET');
}

export const registrarDownloadArquivo = async (idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-download-arquivo/${idArquivo}`, 'POST');
}

export const registrarDownloadPasta = async (idPasta) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-download-pasta/${idPasta}`, 'POST');
}

export const registrarVisualizacaoArquivo = async (idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-visualizacao-arquivo/${idArquivo}`, 'POST');
}

export const registrarVisualizacaoPasta = async (idPasta) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Dashboard/registrar-visualizacao-pasta/${idPasta}`, 'POST');
}